// import React from "react";
// import styled from "styled-components";
// import { RequestItem } from "lib/hooks/requests";
// import { Popover, ConfigProvider } from "antd";
// import { EllipsisOutlined } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import { routeNames } from "lib/routes";
// import { ReactComponent as Delete } from "images/vendor/Iconsdelete.svg";
// import { Link } from "react-router-dom";

// const CardContainer = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   min-width: 800px;
//   padding-top: 16px;
//   padding-bottom: 16px;
//   border-bottom: 1px solid #f0f0f0;
// `;

// const IDColumn = styled.div`
//   width: 15%;
//   margin-left: 1rem;
// `;

// const EmailColumn = styled.div`
//   width: 30%;

// `;

// const StatusColumn = styled.div`
//   width: 20%;

// `;

// const UserTypeColumn = styled.div`
//   width: 15%;

// `;

// const DateColumn = styled.div`
//   width: 20%;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//  `;

// const ActionsColumn = styled.div`

//   display: flex;
//   justify-content: flex-end;
// `;

// const Text = styled.p`
//   margin: 0;
//   font-size: 14px;
//   font-weight: 400;
//   line-height: 24px;
//   text-align: left;
//   color: #2f2f2f;
// `;

// const StatusIndicator = styled.span<{ status: string }>`
//   display: inline-block;
//   padding: 2px 8px;
//   border-radius: 12px;
//   font-size: 12px;
//   font-weight: 500;
//   background-color: ${({ status }) =>
//     status === "pending"
//       ? "#FFF3E0"
//       : status === "approved"
//         ? "#E8F5E9"
//         : status === "rejected"
//           ? "#FFEBEE"
//           : "#E3F2FD"};
//   color: ${({ status }) =>
//     status === "pending"
//       ? "#E65100"
//       : status === "approved"
//         ? "#2E7D32"
//         : status === "rejected"
//           ? "#C62828"
//           : "#1565C0"};
// `;

// const MenuOption = styled.div`
//   padding: 0.5rem;
//   background-color: #f9fbff;
//   border-radius: 8px;
//   width: 8rem;
// `;

// const MenuItem = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   gap: 0.5rem;
//   cursor: pointer;
//   padding: 0.25rem 0;
// `;

// const MenuText = styled.p`
//   margin: 0;
//   font-size: 12px;
//   font-weight: 500;
//   line-height: 22px;
// `;

// const StyledLink = styled(Link)`
//   text-decoration: none;
//   display: flex;
//   flex-direction: row;
//   width: 100%;
// `;

// interface RequestCardProps {
//   request: RequestItem;
// }

// const RequestCard: React.FC<RequestCardProps> = ({ request }) => {
//   const [popoverVisible, setPopoverVisible] = React.useState(false);
//   const navigate = useNavigate();

//   const formatDate = (dateString: string) => {
//     return new Date(dateString).toLocaleDateString();
//   };

//   const getStatusText = (status: string) => {
//     switch (status) {
//       case "pending":
//         return "Pending";
//       case "approved":
//         return "Approved";
//       case "rejected":
//         return "Rejected";
//       case "completed":
//         return "Completed";
//       default:
//         return status;
//     }
//   };

//   const getUserTypeText = (userType: string) => {
//     switch (userType) {
//       case "organizer":
//         return "Organizer";
//       case "vendor":
//         return "Vendor";
//       case "admin":
//         return "Admin";
//       default:
//         return userType;
//     }
//   };

//   const content = (
//     <MenuOption>
//       <MenuItem
//         onClick={() => {
//           // Handle view details action
//           // navigate(`${routeNames.adminRequestDetails}/${request.id}`);
//           setPopoverVisible(false);
//         }}
//       >
//         <MenuText>View Details</MenuText>
//       </MenuItem>
//       <MenuItem
//         onClick={() => {
//           // Handle approve/reject action
//           setPopoverVisible(false);
//         }}
//       >
//         <Delete />
//         <MenuText>Take Action</MenuText>
//       </MenuItem>
//     </MenuOption>
//   );

//   return (
//     <CardContainer>
//       <StyledLink to="">
//         <IDColumn>
//           <Text>#{request.id}</Text>
//         </IDColumn>
//         <EmailColumn>
//           <Text>{request.userEmail || "N/A"}</Text>
//         </EmailColumn>
//         <StatusColumn>
//           <StatusIndicator status={request.status}>{getStatusText(request.status)}</StatusIndicator>
//         </StatusColumn>
//         <UserTypeColumn>
//           <Text>{getUserTypeText(request.userType)}</Text>
//         </UserTypeColumn>
//         <DateColumn>
//           <Text>{formatDate(request.createdAt)}</Text>
//              <ActionsColumn>
//         <ConfigProvider>
//           <Popover
//             placement="bottomRight"
//             content={content}
//             trigger="click"
//             visible={popoverVisible}
//             onVisibleChange={visible => setPopoverVisible(visible)}
//           >
//             <EllipsisOutlined style={{ cursor: "pointer" }} />
//           </Popover>
//         </ConfigProvider>
//       </ActionsColumn>
//         </DateColumn>
//       </StyledLink>

//     </CardContainer>
//   );
// };

// export default RequestCard;

import React from "react";
import styled from "styled-components";
import { RequestItem } from "lib/hooks/requests";
import { Popover, ConfigProvider } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { routeNames } from "lib/routes";
import { ReactComponent as Delete } from "images/vendor/Iconsdelete.svg";
import { Link } from "react-router-dom";
import { ReactComponent as PendingIcon } from "images/organizerevents/draft.svg"; // You'll need to create/import these icons
import { ReactComponent as ApprovedIcon } from "images/organizerevents/Iconupcomingevents.svg";
import { ReactComponent as RejectedIcon } from "images/organizerevents/concluded.svg";
import { ReactComponent as CompletedIcon } from "images/organizerevents/concluded.svg"; // You can use a different icon for completed

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 800px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
`;

const IDColumn = styled.div`
  width: 15%;
  margin-left: 1rem;
`;

const EmailColumn = styled.div`
  width: 30%;
`;

const StatusColumn = styled.div`
  width: 20%;
`;

const UserTypeColumn = styled.div`
  width: 15%;
`;

const DateColumn = styled.div`
  width: 20%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ActionsColumn = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #2f2f2f;
`;

const StatusButton = styled.button<{ bgColor: string; textColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  border: none;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  width: 7rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
  }
`;

const MenuOption = styled.div`
  padding: 0.5rem;
  background-color: #f9fbff;
  border-radius: 8px;
  width: 8rem;
`;

const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.25rem 0;
`;

const MenuText = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

interface RequestCardProps {
  request: RequestItem;
}

const RequestCard: React.FC<RequestCardProps> = ({ request }) => {
  const [popoverVisible, setPopoverVisible] = React.useState(false);
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case "pending":
        return "Pending";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "completed":
        return "Completed";
      default:
        return status;
    }
  };

  const getUserTypeText = (userType: string) => {
    switch (userType) {
      case "organizer":
        return "Organizer";
      case "vendor":
        return "Vendor";
      case "admin":
        return "Admin";
      default:
        return userType;
    }
  };

  const getStatusButtonProps = (status: string) => {
    switch (status) {
      case "pending":
        return {
          text: "Pending",
          color: "#FFF3E0",
          textcolor: "#E65100",
          Icon: PendingIcon,
        };
      case "approved":
        return {
          text: "Approved",
          color: "#E8F5E9",
          textcolor: "#2E7D32",
          Icon: ApprovedIcon,
        };
      case "rejected":
        return {
          text: "Rejected",
          color: "#FFEBEE",
          textcolor: "#C62828",
          Icon: RejectedIcon,
        };
      case "completed":
        return {
          text: "Completed",
          color: "#E3F2FD",
          textcolor: "#1565C0",
          Icon: CompletedIcon,
        };
      default:
        return {
          text: "Pending",
          color: "#FFF3E0",
          textcolor: "#E65100",
          Icon: PendingIcon,
        };
    }
  };

  const { text, color, textcolor, Icon } = getStatusButtonProps(request.status);

  const content = (
    <MenuOption>
      <MenuItem
        onClick={() => {
          setPopoverVisible(false);
        }}
      >
        <MenuText>View Details</MenuText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          setPopoverVisible(false);
        }}
      >
        <Delete />
        <MenuText>Take Action</MenuText>
      </MenuItem>
    </MenuOption>
  );

  return (
    <CardContainer>
      <StyledLink to="">
        <IDColumn>
          <Text>#{request.id}</Text>
        </IDColumn>
        <EmailColumn>
          <Text>{request.userEmail || "N/A"}</Text>
        </EmailColumn>
        <StatusColumn>
          <StatusButton bgColor={color} textColor={textcolor}>
            <Icon style={{ marginRight: "8px" }} />
            {text}
          </StatusButton>
        </StatusColumn>
        <UserTypeColumn>
          <Text>{getUserTypeText(request.userType)}</Text>
        </UserTypeColumn>
        <DateColumn>
          <Text>{formatDate(request.createdAt)}</Text>
          <ActionsColumn>
            <ConfigProvider>
              <Popover
                placement="bottomRight"
                content={content}
                trigger="click"
                visible={popoverVisible}
                onVisibleChange={visible => setPopoverVisible(visible)}
              >
                <EllipsisOutlined style={{ cursor: "pointer" }} />
              </Popover>
            </ConfigProvider>
          </ActionsColumn>
        </DateColumn>
      </StyledLink>
    </CardContainer>
  );
};

export default RequestCard;
